import styled from 'styled-components'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { pxToVh } from '../../../utils/styles-utils'
import Typography from '../../../components/UI/Typography'
import { VStack } from '../../../global/styles'

export const OrderContentWrapper = styled(OverlayScrollbarsComponent).attrs({
  options: {
    scrollbars: { visibility: 'hidden' }
  }
})`
  height: 100%;
  width: 100%;
  padding: 0;
  margin-top: ${pxToVh(120)};
`
export const OrdersWrap = styled(VStack)`
  padding: 0 16px;
  margin-bottom: 50px;
`
export const IsEmptyText = styled(Typography)`
  margin-top: 30px;
  color: ${({ theme }) => theme.colors.skyNeutral_1};
  text-align: center;
  align-self: center;
`
export const ShopsWrap = styled(VStack)`
  /* mobile */  
  padding-bottom: 70px;
`
export const ShopWrap = styled(Typography).attrs({
  variant: 'textL',
  bold: true
})`
`
export const TotalWrap = styled(Typography).attrs(({ theme }) => ({
  variant: 'textM',
  color: theme.colors.skyNeutral_1
}))`
  margin-right: 20px;
`